import React from 'react'
import PropTypes from 'prop-types'

const PauseIcon = React.memo(({ stroke }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
      <g id="Group_440" data-name="Group 440" transform="translate(-1651 -73)">
        <g id="Rectangle_2146" data-name="Rectangle 2146" transform="translate(1651 73)" fill="none" stroke={stroke} strokeWidth="1">
          <rect width="4" height="14" stroke="none"/>
          <rect x="0.5" y="0.5" width="3" height="15" fill="#FFF"/>
        </g>
        <g id="Rectangle_2147" data-name="Rectangle 2147" transform="translate(1657 73)" fill="none" stroke={stroke} strokeWidth="1">
          <rect width="4" height="14" stroke="none"/>
          <rect x="0.5" y="0.5" width="3" height="15" fill="#FFF"/>
        </g>
      </g>
    </svg>
  )
})

PauseIcon.propTypes = {
  stroke: PropTypes.string
}

PauseIcon.defaultProps = {
  stroke: "#FFF"
}

export {PauseIcon}